import React from "react";
import { withRouter } from "react-router";
import AgregarCodigoCupon from "./AgregarCodigoCupon";

const EditarCodigoCupon = props => {
    return <AgregarCodigoCupon editar={true} />;
};

export default withRouter(EditarCodigoCupon);

